
export default {
  name: 'MarginCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "How does a gross margin calculator work?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A gross margin calculator can do a lot of work: Find the revenue, divide gross profit, and express results as a percentage to calculate margins."
        }
      },{
        "@type": "Question",
        "name": "What is a 20% margin?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A 20% return will have a markup gross margin percentage of 25%."
        }
      },{
        "@type": "Question",
        "name": "How much is a 50% margin?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The 50% profit margin is relatively high. For further explanation, when your cost per product is $100 while the resale price is $200, the gross profit margin is 50%."
        }
      },{
        "@type": "Question",
        "name": "How do I calculate a 40% margin?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The profit margin formula to calculate profit per product is: Selling price = Cost / (1-GM%). While applying the above one, to achieve 40% profit on the initial cost of 100 USD, you will get: Selling price = 100/(1-0.4)= 166.6. To sell a $100 item with a 40% profit, you would have to sell that item for $166.6."
        }
      },{
        "@type": "Question",
        "name": "What is a good margin?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A reasonable profit margin will depend on the size of the business and the business sector. Typically, an excellent after-tax profit margin for an SME will be in the range of 7% - 10%. Retail companies will have lower profit margins. The reason is that these companies have to spend a lot of money to maintain operations."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        type: 'profit',
        cost: null,
        gross_margin: null,
        stock_price: null,
        number_of_shares: null,
        margin_requirement: null,
        exchange_rate: null,
        margin_ratio: 20,
        units: null
      })
    }
  },
  methods: {
    onMarginCalculator() {
        this.form.post(`/tool/margin-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.cost               = 100;
        this.form.gross_margin       = 5;

        this.form.stock_price        = 18;
        this.form.number_of_shares   = 100;
        this.form.margin_requirement = 30;

        this.form.exchange_rate      = 1.5;
        this.form.margin_ratio       = 20;
        this.form.units              = 100;
    },
    onReset(){
        this.form.reset();
        this.data = null;
    }
  }
}
